import React, { useState } from 'react';
import { sendContactEmail } from '../../services/emailService';
import { ContactFormData, FormStatus } from '../../types';
import SectionLabel from '../ui/SectionLabel';
import './Contact.css';

const INITIAL: ContactFormData = { firstName:'', lastName:'', email:'', service:'Computer Vision', message:'' };

const Contact: React.FC = () => {
  const [form, setForm]     = useState<ContactFormData>(INITIAL);
  const [status, setStatus] = useState<FormStatus>('idle');

  const onChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('sending');
    try {
      await sendContactEmail({
        from_name:  `${form.firstName} ${form.lastName}`.trim(),
        from_email: form.email,
        service:    form.service,
        message:    form.message,
      });
      setStatus('sent');
      setTimeout(() => { setForm(INITIAL); setStatus('idle'); }, 3000);
    } catch (err) {
      console.error(err);
      setStatus('idle');
      alert('Something went wrong. Please try again.');
    }
  };

  return (
    <section className="section contact" id="contact">

      <div className="contact__head reveal">
        <SectionLabel text="Get In Touch" />
        <h2 className="contact__title">
          Start Your AI<br /><em>Transformation</em>
        </h2>
        <p className="contact__sub">
          Tell us about your challenge — we'll respond within one business day
          with a clear path forward.
        </p>
      </div>

      <div className="contact__layout">

        {/* ── Info ── */}
        <div className="contact__info reveal">
          {[
            { icon: '📍', label: 'Office',        val: 'PVS Mansion, 5th Floor\n3-1-227 Somasundaram Street\nSecunderabad 500003' },
            { icon: '📞', label: 'Phone',          val: '+91 9866224780' },
            { icon: '📧', label: 'Email',          val: 'info@rapidus-ai.com' },
            { icon: '🌐', label: 'Website',        val: 'www.rapidus-ai.com' },
            { icon: '🕐', label: 'Business Hours', val: 'Mon–Fri, 9 AM – 7 PM IST' },
          ].map(item => (
            <div className="contact__info-item" key={item.label}>
              <div className="contact__info-icon">{item.icon}</div>
              <div>
                <div className="contact__info-label">{item.label}</div>
                <div className="contact__info-val">{item.val}</div>
              </div>
            </div>
          ))}
        </div>

        {/* ── Form ── */}
        <form className="contact__form reveal reveal-delay-1" onSubmit={onSubmit}>
          <div className="contact__form-row">
            <div className="form-group">
              <label className="form-label">First Name</label>
              <input className="form-input" name="firstName" value={form.firstName} onChange={onChange} placeholder="Rahul" required />
            </div>
            <div className="form-group">
              <label className="form-label">Last Name</label>
              <input className="form-input" name="lastName" value={form.lastName} onChange={onChange} placeholder="Sharma" required />
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">Work Email</label>
            <input className="form-input" name="email" type="email" value={form.email} onChange={onChange} placeholder="rahul@company.com" required />
          </div>
          <div className="form-group">
            <label className="form-label">Service Interest</label>
            <select className="form-select" name="service" value={form.service} onChange={onChange}>
              {['Computer Vision','AI / Machine Learning','Business Intelligence','AI Security','Ethical AI','AI Consulting','Talent & Training'].map(s => (
                <option key={s}>{s}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label className="form-label">Tell us about your project</label>
            <textarea className="form-textarea" name="message" value={form.message} onChange={onChange} placeholder="Describe your use case..." required />
          </div>
          <button
            type="submit"
            className="contact__submit"
            disabled={status === 'sending'}
          >
            {status === 'idle'    && 'Send Message →'}
            {status === 'sending' && 'Sending...'}
            {status === 'sent'    && 'Message Sent ✓'}
          </button>
        </form>

      </div>
    </section>
  );
};

export default Contact;